/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import3 from 'angular2-spinner/dist/angular2-spinner';
import * as import4 from '@angular/router';
import * as import5 from '../../../app/pipes/array.pipe';
import * as import6 from '../../../app/pipes/polish-price.pipe';
import * as import7 from '../../../app/cocpit/cocpit.component';
import * as import8 from '../../../app/services/api.service';
import * as import9 from 'ng2-breadcrumb/app/components/breadcrumbService';
import * as import10 from '../../../app/services/messages.service';
import * as import11 from 'angular2-notifications/src/notifications.service';
import * as import12 from 'ng2-slim-loading-bar/src/slim-loading-bar.service';
import * as import13 from '../../../app/services/payments.service';
import * as import14 from '../../../app/services/servers.service';
import * as import15 from '../../../app/services/maintance.service';
const styles_CocpitComponent:any[] = ([] as any[]);
export const RenderType_CocpitComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CocpitComponent,
  data: {}
}
);
function View_CocpitComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['. Czas trwania '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ' min.'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.duration;
    ck(v,3,0,currVal_0);
  });
}
function View_CocpitComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[
      [
        'class',
        'blocks'
      ]
      ,
      [
        'style',
        'display: inherit; margin-bottom: 15px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),14,'div',[
      [
        'class',
        'icon icon-warning'
      ]
      ,
      [
        'style',
        'display: inline'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',[[
        'style',
        'color:red;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                            Zaplanowano na dzień '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'b',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = v.context.$implicit.duration;
    ck(v,15,0,currVal_3);
  },(ck,v) => {
    const currVal_0:any = v.context.$implicit.title;
    ck(v,5,0,currVal_0);
    const currVal_1:any = v.context.$implicit.message;
    ck(v,10,0,currVal_1);
    const currVal_2:any = v.context.$implicit.date_start;
    ck(v,13,0,currVal_2);
  });
}
function View_CocpitComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CocpitComponent_3)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),co.maintanceMessages));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CocpitComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'style',
        'text-align: center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'style',
        'color: #cccccc'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak nowych komunikatów'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'style',
        'text-align: center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'style',
        'color: red'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Błąd podczas pobierania listy komunikatów serwisowych, spróbuj ponownie za chwilę'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie komunikatów serwisowych'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import2.View_SpinnerComponent_0,import2.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import3.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CocpitComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'row-bordered'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[
      [
        'class',
        'blocks heading'
      ]
      ,
      [
        'style',
        'width: 100%; display: inline-block;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'style',
        'color:red'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Komunikaty serwisowe:'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    \n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_7)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = (!co.maintanceMessageLoading && co.maintanceMessages.length);
    ck(v,11,0,currVal_0);
    const currVal_1:boolean = ((!co.maintanceMessageLoading && (co.maintanceMessages !== false)) && !co.maintanceMessages.length);
    ck(v,14,0,currVal_1);
    const currVal_2:boolean = (!co.maintanceMessageLoading && (co.maintanceMessages === false));
    ck(v,17,0,currVal_2);
    const currVal_3:any = co.maintanceMessageLoading;
    ck(v,21,0,currVal_3);
  },(null as any));
}
function View_CocpitComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-danger btn-small'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.payProforma((<any>v.parent).context.$implicit.access_token)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zapłać']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-danger btn-small'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Płatność zablokowana']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[
      [
        'class',
        'blocks'
      ]
      ,
      [
        'style',
        'display: inherit; margin-bottom: 15px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[
      [
        'class',
        'icon icon-warning'
      ]
      ,
      [
        'style',
        'display: inline'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            Nieopłacona faktura ',
      ' dla kontraktu \n                            '
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,5).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import4.RouterLinkWithHref,[
      import4.Router,
      import4.ActivatedRoute,
      import1.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),[
      ' \n                            na kwotę ',
      ' PLN\n                        '
    ]
    )),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'style',
        'float: right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'style',
        'margin-right: 10px;'
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
      ,[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Pobierz fakturę ',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_10)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_11)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_3:any = import0.ɵinlineInterpolate(1,'/contracts/details/',v.context.$implicit.contract_id,'');
    ck(v,5,0,currVal_3);
    const currVal_8:boolean = !v.context.$implicit.blockade_payment;
    ck(v,16,0,currVal_8);
    const currVal_9:any = v.context.$implicit.blockade_payment;
    ck(v,19,0,currVal_9);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵnov(v,5).target;
    const currVal_2:any = import0.ɵnov(v,5).href;
    ck(v,4,0,currVal_1,currVal_2);
    const currVal_4:any = v.context.$implicit.contract;
    ck(v,6,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,7,0,ck(v,8,0,import0.ɵnov((<any>(<any>v.parent).parent),1),v.context.$implicit.price));
    ck(v,7,0,currVal_5);
    const currVal_6:any = import0.ɵinlineInterpolate(2,'',co.invoiceStorageURL,'/invoice/',v.context.$implicit.access_token,'');
    ck(v,12,0,currVal_6);
    const currVal_7:any = ((v.context.$implicit.type === 1)? 'proforma': 'VAT');
    ck(v,13,0,currVal_7);
  });
}
function View_CocpitComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CocpitComponent_9)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,ck(v,4,0,import0.ɵnov((<any>v.parent),0),co.paymentsList));
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_CocpitComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'style',
        'text-align: center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'style',
        'color: #cccccc'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak zaległych płatności'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'style',
        'text-align: center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'style',
        'color: red'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Błąd podczas pobierania listy płatności, proszę spróbować ponownie za chwilę'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
function View_CocpitComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie zaległych płatności'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import2.View_SpinnerComponent_0,import2.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import3.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CocpitComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'icon icon-warning'
      ]
      ,
      [
        'style',
        'display: inline'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            Serwer ',
      ' - STAN: W PRZYGOTOWYWANIU\n                        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.name_external;
    ck(v,1,0,currVal_0);
  });
}
function View_CocpitComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'icon icon-on'
      ]
      ,
      [
        'style',
        'display: inline'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            Serwer ',
      ' - STAN: WŁĄCZONY\n                        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.name_external;
    ck(v,1,0,currVal_0);
  });
}
function View_CocpitComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[
      [
        'class',
        'icon icon-off'
      ]
      ,
      [
        'style',
        'display: inline'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            Serwer ',
      ' - STAN: WYŁĄCZONY\n                        '
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (<any>v.parent).context.$implicit.name_external;
    ck(v,1,0,currVal_0);
  });
}
function View_CocpitComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[
      [
        'class',
        'blocks'
      ]
      ,
      [
        'style',
        'display: inherit; margin-bottom: 15px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_16)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_17)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_18)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        \n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'style',
        'float: right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',([] as any[]),[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,14).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import4.RouterLinkWithHref,[
      import4.Router,
      import4.ActivatedRoute,
      import1.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Przejdź do serwera'])),
    (l()(),import0.ɵted((null as any),[' | \n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-success btn-small'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.buyServices(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dokup usługi'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = (v.context.$implicit.status != 'active');
    ck(v,3,0,currVal_0);
    const currVal_1:any = ((v.context.$implicit.status == 'active') && v.context.$implicit.power_status);
    ck(v,6,0,currVal_1);
    const currVal_2:any = ((v.context.$implicit.status == 'active') && !v.context.$implicit.power_status);
    ck(v,9,0,currVal_2);
    const currVal_5:any = import0.ɵinlineInterpolate(2,'/server/dashboard/',v.context.$implicit.contract.id,'/',v.context.$implicit.service,'');
    ck(v,14,0,currVal_5);
  },(ck,v) => {
    const currVal_3:any = import0.ɵnov(v,14).target;
    const currVal_4:any = import0.ɵnov(v,14).href;
    ck(v,13,0,currVal_3,currVal_4);
  });
}
function View_CocpitComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'style',
        'text-align: center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',[[
        'style',
        'color: #cccccc'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak serwerów'])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(null as any));
}
export function View_CocpitComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import5.ArrayPipe,([] as any[])),
    import0.ɵpid(0,import6.PolishPricePipe,([] as any[])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),59,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),56,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'row-bordered'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'div',[
      [
        'class',
        'blocks heading'
      ]
      ,
      [
        'style',
        'width: 100%; display: inline-block;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Płatności:'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_8)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_12)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_13)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_14)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'row-bordered'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[
      [
        'class',
        'blocks heading'
      ]
      ,
      [
        'style',
        'width: 100%; display: inline-block;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Serwery:'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),2,(null as any),View_CocpitComponent_15)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                 '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CocpitComponent_19)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'column-set-2'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.CocpitComponent = v.component;
    const currVal_0:boolean = (!co.maintanceMessageLoading && co.maintanceMessages.length);
    ck(v,7,0,currVal_0);
    const currVal_1:boolean = (!co.paymentsLoading && co.paymentsList.length);
    ck(v,20,0,currVal_1);
    const currVal_2:boolean = ((!co.paymentsLoading && (co.paymentsList !== false)) && !co.paymentsList.length);
    ck(v,23,0,currVal_2);
    const currVal_3:boolean = (!co.paymentsLoading && (co.paymentsList === false));
    ck(v,26,0,currVal_3);
    const currVal_4:any = co.paymentsLoading;
    ck(v,30,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,46,0,ck(v,47,0,import0.ɵnov(v,0),co.serversList));
    ck(v,46,0,currVal_5);
    const currVal_6:boolean = !co.serversList.length;
    ck(v,51,0,currVal_6);
  },(null as any));
}
function View_CocpitComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_CocpitComponent_0,RenderType_CocpitComponent)),
    import0.ɵdid(114688,(null as any),0,import7.CocpitComponent,[
      import8.ApiService,
      import4.Router,
      import9.BreadcrumbService,
      import10.MessagesService,
      import11.NotificationsService,
      import12.SlimLoadingBarService,
      import13.PaymentsService,
      import14.ServersService,
      import15.MaintanceService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const CocpitComponentNgFactory:import0.ComponentFactory<import7.CocpitComponent> = import0.ɵccf('app-main',import7.CocpitComponent,View_CocpitComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/cocpit/cocpit.component.ngfactory.ts